import { Directive, OnInit, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[gisWidgetDropArea]',
    standalone: false
})
export class WidgetDropAreaDirective implements OnInit {
  constructor(private _dropContainer: ElementRef, private _renderer: Renderer2) {}

  ngOnInit() {
    this.enableWidgetDrop();
  }

  private enableWidgetDrop() {
    this._renderer.listen(this._dropContainer.nativeElement, 'dragover', event => {
      event.preventDefault();
    });

    this._renderer.listen(this._dropContainer.nativeElement, 'drop', event => {
      this.drop(event);
    });
  }

  /**
   * @function drop
   * @param event The event object containing the droppable DOM element
   * @description Get the transfered object from drag event and computed the
   * new position for the dragged element
   */
  private drop(event) {
    event.preventDefault();
    const transferredObject = JSON.parse(event.dataTransfer.getData('draggedElement'));
    const htmlElement = document.getElementById(transferredObject.sourceID);
    htmlElement.style.left = event.clientX + parseInt(transferredObject.x, 10) + 'px';
    htmlElement.style.top = event.clientY + parseInt(transferredObject.y, 10) + 'px';
  }
}
